import { FC, useMemo, useState } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { getAdPreviewPropsFromRowData } from 'wb-spotify/app/routes/superGrid/cellRenderers/utils/adPreview';
import { AdPreview } from '@aleph/shared-components';

const getRowId = (p: ICellRendererParams): string => {
	const d = p.data;

	if (d) {
		const key = [d.id ?? d.hash, d.level, d.field ?? d.colId].filter(Boolean).join('_');
		if (key) return key;
	}

	return p.node?.id ?? String(p.rowIndex);
};

const persistedByRow = new Map<string, { isMobile: boolean; currentScreen: number }>();

const AdPreviewCellRenderer: FC<ICellRendererParams> = (params) => {
	const id = getRowId(params);
	const stored = persistedByRow.get(id);
	const [isMobile, setIsMobile] = useState(stored?.isMobile ?? true);
	const [adPreviewCurrentScreen, setAdPreviewCurrentScreen] = useState(stored?.currentScreen ?? 0);

	const setPersistedIsMobile = (value: boolean) => {
		persistedByRow.set(id, { isMobile: value, currentScreen: adPreviewCurrentScreen });
		setIsMobile(value);
	};

	const setPersistedCurrentScreen = (value: number) => {
		persistedByRow.set(id, { isMobile, currentScreen: value });
		setAdPreviewCurrentScreen(value);
	};

	const adPreviewData = useMemo(
		() => getAdPreviewPropsFromRowData(params.data ?? null),
		[params.data],
	);

	return (
		<div
			className="w-full h-full px-[8px] max-h-full font-medium"
			data-testid="ad-preview"
		>
			<AdPreview
				{...adPreviewData}
				scale
				isMobile={isMobile}
				setIsMobile={setPersistedIsMobile}
				adPreviewCurrentScreen={adPreviewCurrentScreen}
				setAdPreviewCurrentScreen={setPersistedCurrentScreen}
			/>
		</div>
	);
};

export default AdPreviewCellRenderer;
